import React, { useEffect, useState } from "react";
import Style from "../style/filtercategorycontent.module.scss";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { fetchCategory } from "../redux/Slice";
import { useParams } from "react-router-dom";

const FilterCategoryContent = () => {
  const { userCategory } = useParams();
  const dispatch = useAppDispatch();
  const data = useAppSelector((state) => state.detail);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    dispatch(fetchCategory());
  }, [dispatch]);

  const filterData = data.categoryData?.categories.filter(
    (item) => item.slug === userCategory
  );
  const content = filterData?.[0]?.description || "";

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div
          className={`${Style.content} ${!expanded ? Style.collapsed : ""}`}
          dangerouslySetInnerHTML={{ __html: content }}
        />
        {content && (
          <button
            className={Style.toggleButton}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "View Less" : "View More"}
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterCategoryContent;
